if (!window.__aldoCardSiblingSwatchesBound) {
  window.__aldoCardSiblingSwatchesBound = true;

  document.addEventListener('DOMContentLoaded', function () {
    const observerOptions = {
      root: null,
      rootMargin: '-110px 0px 0px 0px',
      threshold: 0,
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        requestAnimationFrame(() => {
          if (!entry.isIntersecting) {
            entry.target.classList.add('is-hidden-optimized');
          } else {
            entry.target.classList.remove('is-hidden-optimized');
          }
        });
      });
    }, observerOptions);

    const elementsToWatch = document.querySelectorAll(
      '.wishlist-button-container, .card__colors-wrapper'
    );

    elementsToWatch.forEach((el) => {
      observer.observe(el);
    });
  });


  // --------------------------------------------------
  // MONEY FORMAT
  // --------------------------------------------------

  function formatMoneyEuro(cents) {
    try {
      return (
        (cents / 100).toLocaleString('el-GR', {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        }) + '€'
      );
    } catch (e) {
      return (cents / 100).toFixed(2) + '€';
    }
  }


  // --------------------------------------------------
  // PRODUCT CACHE
  // --------------------------------------------------

  const siblingProductCache = new Map();


  // --------------------------------------------------
  // PRODUCT TITLE
  // --------------------------------------------------

  function formatModelTitle(rawTitle) {
    const title = String(rawTitle || '').trim();

    if (!title) return '';

    const mainPart = title.split(' - ')[0].trim();
    const parts = mainPart.split(/\s+/).filter(Boolean);
    const firstWord = (parts[0] || '').toLowerCase();

    let modelPart = '';

    if (firstWord === 'aldo' && parts.length > 1) {
      modelPart = parts[1];
    } else {
      modelPart = parts[0] || '';
    }

    if (!modelPart) {
      modelPart = title;
    }

    const formatted = modelPart
      .split('-')
      .map((part) => {
        const s = part.trim().toLowerCase();

        return s
          ? s.charAt(0).toUpperCase() + s.slice(1)
          : '';
      })
      .filter(Boolean)
      .join('-');

    return formatted || modelPart;
  }


  function updateCardTitleLink(link, productData) {
    if (!link || !productData) return;

    link.href = productData.url || link.href;

    const formattedTitle =
      formatModelTitle(productData.title) || link.textContent;

    const existingTypeSpan =
      link.querySelector('.card__title-type');

    if (existingTypeSpan) {
      const typeClone =
        existingTypeSpan.cloneNode(true);

      link.textContent = '';

      link.appendChild(
        document.createTextNode(formattedTitle)
      );

      link.appendChild(typeClone);
    } else {
      link.textContent = formattedTitle;
    }
  }


  // --------------------------------------------------
  // LOAD SIBLING PRODUCT
  // --------------------------------------------------

  async function getSiblingProductData(productUrl) {
    if (!productUrl) return null;

    if (siblingProductCache.has(productUrl)) {
      return siblingProductCache.get(productUrl);
    }

    const request = fetch(productUrl + '.js')
      .then((response) =>
        response.ok ? response.json() : null
      )
      .catch(() => null);

    siblingProductCache.set(
      productUrl,
      request
    );

    return request;
  }


  // --------------------------------------------------
  // PREFETCH SIBLING PRODUCTS
  // --------------------------------------------------

  function prefetchSiblingProducts() {
    const swatches =
      document.querySelectorAll(
        '.js-card-sibling-swatch[data-product-url]'
      );

    swatches.forEach((swatch) => {
      const url =
        swatch.dataset.productUrl;

      if (url) {
        getSiblingProductData(url);
      }
    });
  }


  if ('requestIdleCallback' in window) {
    window.requestIdleCallback(
      prefetchSiblingProducts,
      { timeout: 1200 }
    );
  } else {
    setTimeout(
      prefetchSiblingProducts,
      250
    );
  }


  // --------------------------------------------------
  // SWATCH CLICK
  // --------------------------------------------------

  document.addEventListener(
    'click',
    async function (e) {

      const swatch =
        e.target.closest(
          '.js-card-sibling-swatch'
        );

      if (!swatch) return;

      e.preventDefault();
      e.stopPropagation();

      const cardWrapper =
        swatch.closest(
          '.product-card-wrapper'
        );

      const productUrl =
        swatch.dataset.productUrl;

      if (!cardWrapper || !productUrl) {
        return;
      }


      try {

        const productData =
          await getSiblingProductData(
            productUrl
          );

        if (!productData) return;


        // ==========================================
        // UPDATE TITLE
        // ==========================================

        const titleLinks =
          cardWrapper.querySelectorAll(
            '.card__heading a'
          );

        titleLinks.forEach((link) => {
          updateCardTitleLink(
            link,
            productData
          );
        });


        // ==========================================
        // UPDATE PRODUCT LINK
        // ==========================================

        const mediaLink =
          cardWrapper.querySelector(
            '.card__media-link'
          );

        if (mediaLink) {
          mediaLink.href =
            productData.url;

          mediaLink.setAttribute(
            'aria-label',
            productData.title || ''
          );
        }


        // ==========================================
        // UPDATE IMAGES AFTER SWATCH CHANGE
        // ==========================================
        // Swatch click always shows the selected product's
        // featured image first. The second image is prepared,
        // but can appear only on a NEW hover over the photo.

        const mediaContainer =
          cardWrapper.querySelector('.aldo-plp-image-container');

        const mainImg =
          cardWrapper.querySelector('.aldo-plp-main-image');

        let hoverImg =
          cardWrapper.querySelector('.aldo-plp-hover-image');

        const featuredImg = productData.featured_image;

        // Lock photo hover immediately on swatch selection.
        // If the pointer is already outside the photo, the next
        // pointer-enter may unlock it immediately. If it is still
        // over the photo, it must leave first and then re-enter.
        if (mediaLink) {
          const pointerAlreadyOnPhoto = mediaLink.matches(':hover');
          mediaLink.classList.add('aldo-hover-locked');
          mediaLink.dataset.aldoHoverCanUnlock =
            pointerAlreadyOnPhoto ? 'false' : 'true';
        }

        // MAIN = selected sibling's featured / first image
        if (mainImg && featuredImg) {
          mainImg.src = featuredImg;
          mainImg.srcset = featuredImg + ' 533w';
          mainImg.alt = productData.title || mainImg.alt;
          mainImg.style.removeProperty('opacity');
        }

        // HOVER priority for the selected sibling:
        // lifestyle first, then alt3 fallback.
        const productImages =
          Array.isArray(productData.images) ? productData.images : [];

        const findImageByName = (name) =>
          productImages.find((imageUrl) =>
            String(imageUrl || '').toLowerCase().includes(name)
          );

        const selectedHoverImage =
          findImageByName('elevated-look') ||
          findImageByName('campaign-full') ||
          findImageByName('campaign-part') ||
          findImageByName('look-full') ||
          findImageByName('alt3') ||
          null;

        if (selectedHoverImage && mainImg) {
          if (!hoverImg) {
            hoverImg = mainImg.cloneNode(false);
            hoverImg.classList.remove('aldo-plp-main-image');
            hoverImg.classList.add('aldo-plp-hover-image');
            mainImg.insertAdjacentElement('afterend', hoverImg);
          }

          hoverImg.src = selectedHoverImage;
          hoverImg.srcset = selectedHoverImage + ' 533w';
          hoverImg.alt = productData.title || mainImg.alt;
          hoverImg.loading = 'lazy';
          hoverImg.style.removeProperty('opacity');

          if (mediaContainer) {
            mediaContainer.classList.add('media--hover-effect');
          }
        } else {
          if (hoverImg) {
            hoverImg.remove();
          }

          if (mediaContainer) {
            mediaContainer.classList.remove('media--hover-effect');
          }
        }

        // ==========================================
        // PRICE / SALE STATE
        // ==========================================

        const priceContainer =
          cardWrapper.querySelector(
            '.price'
          );


        const regularPriceEl =
          cardWrapper.querySelector(
            '.price__regular .price-item--regular'
          );


        const salePriceEl =
          cardWrapper.querySelector(
            '.price__sale .price-item--sale'
          );


        const compareAtEl =
          cardWrapper.querySelector(
            '.price__sale s.price-item--regular'
          );


        // ==========================================
        // STATUS LABELS
        // ==========================================

        const lastChanceEl =
          cardWrapper.querySelector(
            '.card-last-chance'
          );

        const offerLabelEl =
          cardWrapper.querySelector(
            '.aldo-offer-label'
          );

        const lowStockEl =
          cardWrapper.querySelector(
            '.card-low-stock'
          );


        // ==========================================
        // CHECK SALE
        // ==========================================

        const isOnSale =
          productData.compare_at_price &&
          productData.compare_at_price >
            productData.price;


       // ==========================================
// CHECK IF PRODUCT ACTUALLY HAS A SIZE OPTION
// ==========================================

const hasSizeOption =
  Array.isArray(productData.options) &&
  productData.options.some((option) => {
    const optionName =
      typeof option === 'string'
        ? option
        : option.name;

    const normalizedName =
      String(optionName || '')
        .trim()
        .toLowerCase();

    return (
      normalizedName === 'size' ||
      normalizedName === 'μέγεθος'
    );
  });


// ==========================================
// COUNT AVAILABLE SIZES
// Only relevant when product has Size option
// ==========================================

const availableSizeCount =
  hasSizeOption &&
  Array.isArray(productData.variants)
    ? productData.variants.filter(
        (variant) => variant.available
      ).length
    : 0;


// ==========================================
// LOW STOCK
// Only footwear / products with Size option
// ==========================================

const isLowStock =
  hasSizeOption &&
  availableSizeCount <= 2;

        // ==========================================
        // UPDATE SALE / REGULAR PRICE
        // ==========================================

        if (isOnSale) {

          // -----------------------------
          // SALE PRODUCT
          // -----------------------------

          if (priceContainer) {
            priceContainer.classList.add(
              'price--on-sale'
            );
          }


          if (salePriceEl) {
            salePriceEl.textContent =
              formatMoneyEuro(
                productData.price
              );
          }


          if (compareAtEl) {
            compareAtEl.textContent =
              formatMoneyEuro(
                productData.compare_at_price
              );
          }


          // Offer always follows sale state

          if (offerLabelEl) {
            offerLabelEl.style.display =
              '';
          }

        } else {

          // -----------------------------
          // FULL PRICE PRODUCT
          // -----------------------------

          if (priceContainer) {
            priceContainer.classList.remove(
              'price--on-sale'
            );
          }


          if (regularPriceEl) {
            regularPriceEl.textContent =
              formatMoneyEuro(
                productData.price
              );
          }


          if (salePriceEl) {
            salePriceEl.textContent =
              '';
          }


          if (compareAtEl) {
            compareAtEl.textContent =
              '';
          }


          // No sale = no Offer

          if (offerLabelEl) {
            offerLabelEl.style.display =
              'none';
          }
        }


        // ==========================================
// STATUS PRIORITY
//
// Applies ONLY to products with Size.
//
// 1. LOW STOCK = 1-2 available sizes
// 2. LAST CHANCE = sale + more than 2 sizes
// 3. NOTHING
//
// Bags/accessories without Size = NOTHING
// ==========================================

if (!hasSizeOption) {

  // Bag / accessory / non-size product
  if (lowStockEl) {
    lowStockEl.style.display = 'none';
  }

  if (lastChanceEl) {
    lastChanceEl.style.display = 'none';
  }

} else if (isLowStock) {

  // Size product with 1-2 sizes
  if (lowStockEl) {
    lowStockEl.style.display = '';
  }

  if (lastChanceEl) {
    lastChanceEl.style.display = 'none';
  }

} else if (isOnSale) {

  // Size product with 3+ sizes and discounted
  if (lowStockEl) {
    lowStockEl.style.display = 'none';
  }

  if (lastChanceEl) {
    lastChanceEl.style.display = '';
  }

} else {

  // Size product, but no status applies
  if (lowStockEl) {
    lowStockEl.style.display = 'none';
  }

  if (lastChanceEl) {
    lastChanceEl.style.display = 'none';
  }
}
 
        // ==========================================
        // QUICK ADD VARIANT
        // ==========================================

        const quickAddInput =
          cardWrapper.querySelector(
            'input.product-variant-id[name="id"]'
          );


        if (
          quickAddInput &&
          Array.isArray(
            productData.variants
          ) &&
          productData.variants.length
        ) {

          const firstAvailable =
            productData.variants.find(
              (v) => v.available
            ) ||
            productData.variants[0];


          quickAddInput.value =
            firstAvailable.id;
        }


        // ==========================================
        // CHOOSE OPTIONS URL
        // ==========================================

        const chooseOptionsButton =
          cardWrapper.querySelector(
            '.quick-add__submit[data-product-url]'
          );


        if (chooseOptionsButton) {
          chooseOptionsButton.setAttribute(
            'data-product-url',
            productData.url
          );
        }


        // ==========================================
        // UPDATE ACTIVE SWATCH
        // ==========================================

        const swatches =
          cardWrapper.querySelectorAll(
            '.js-card-sibling-swatch'
          );


        swatches.forEach((dot) => {

          dot.dataset.swatchActive =
            'false';

          dot.style.border =
            '1px solid #e2e2e2';

          dot.style.boxShadow =
            'none';
        });


        swatch.dataset.swatchActive =
          'true';

        swatch.style.border =
          '1px solid #000';

        swatch.style.boxShadow =
          '0 0 0 1px #fff, 0 0 0 2px #000';


      } catch (err) {

        console.error(
          'Sibling swatch card update failed',
          err
        );

        window.location.href =
          productUrl;
      }
    }
  );


  // --------------------------------------------------
  // PHOTO HOVER UNLOCK AFTER SWATCH CHANGE
  // --------------------------------------------------
  // A swatch click itself never reveals image #2.
  // Image #2 is enabled only by a subsequent pointer-enter
  // on the actual product photo.

  document.addEventListener(
    'pointerleave',
    function (e) {
      const mediaLink =
        e.target.closest && e.target.closest('.card__media-link');

      if (!mediaLink || !mediaLink.classList.contains('aldo-hover-locked')) {
        return;
      }

      mediaLink.dataset.aldoHoverCanUnlock = 'true';
    },
    true
  );

  document.addEventListener(
    'pointerenter',
    function (e) {
      const mediaLink =
        e.target.closest && e.target.closest('.card__media-link');

      if (!mediaLink || !mediaLink.classList.contains('aldo-hover-locked')) {
        return;
      }

      if (mediaLink.dataset.aldoHoverCanUnlock !== 'true') {
        return;
      }

      mediaLink.classList.remove('aldo-hover-locked');
      delete mediaLink.dataset.aldoHoverCanUnlock;
    },
    true
  );

  // --------------------------------------------------
  // WARM CACHE ON MOUSEOVER
  // --------------------------------------------------

  document.addEventListener(
    'mouseover',
    function (e) {

      const swatch =
        e.target.closest(
          '.js-card-sibling-swatch[data-product-url]'
        );

      if (!swatch) return;

      getSiblingProductData(
        swatch.dataset.productUrl
      );
    }
  );


  // --------------------------------------------------
  // WARM CACHE ON TOUCH
  // --------------------------------------------------

  document.addEventListener(
    'touchstart',
    function (e) {

      const swatch =
        e.target.closest(
          '.js-card-sibling-swatch[data-product-url]'
        );

      if (!swatch) return;

      getSiblingProductData(
        swatch.dataset.productUrl
      );
    },
    {
      passive: true,
    }
  );
}